var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-tip"},[_c('img',{attrs:{"src":_vm.loginIcon,"width":"30","alt":""}}),_c('span',{staticClass:"tip-text"},[_vm._v(_vm._s(_vm.$t('mobile.moreService')))]),_c('el-button',{attrs:{"type":"primary","size":"small","round":true},on:{"click":_vm.goLogin}},[_vm._v(_vm._s(_vm.$t('mobile.toLogin')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }